export const environment = {
  production: false,
  apiUrl: 'https://api-hml-patiocontrol.azurewebsites.net/api/admin'
};
